import { router } from './router';
import store from './store';
import { getToken , getAllUrlParams } from './utils/auth';
// import { wxshare } from '@/utils/share';

router.beforeEach((to, from, next) => {
	console.log('路由钩子，目的地：' + to.path)
	const title = to.meta && to.meta.title;
	if(title) {
		document.title = title;
	}
	
	console.log(store.state.user)
	
	// 保存滚动条
	if(from.path == '/index/yhlist' || from.path == '/index/ghlist' || from.path == '/index/sflist'){
		let top= document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度
		console.log(top)
		store.dispatch('hua/setscrolltop', top)
	}
	
	next()
	
	// if(getToken()) {
	// 	next()	
	// }
	
	// else{
	// 	if(getAllUrlParams().code) {
			
	// 		let data = getAllUrlParams()
	// 		data.logintype = 'public'
	// 		//获取token
	// 		store.dispatch('user/login', data).then(() => {
	// 			//跳转首页
	// 			next({ path: '/'});
 //            })
	// 	}
	// 	else{
	// 		//无token，进行微信授权
	// 		let appId = 'wxd2fa2b94b7ca9926'
	// 		let myurl = process.env.VUE_APP_REDIRECTURL
	// 		let type = 'public'
	// 		let redirectUrl = encodeURIComponent(`http://server.172art.top/otherwechatauth?myurl=${myurl}&type=${type}`)
			
	// 		let ua = window.navigator.userAgent.toLowerCase()
	// 	    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
	// 	        // 跳转到微信授权页面
	// 			window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
	// 	    }
	// 	    else{
	// 	      	console.log('请使用微信登录')
	// 	      	return false;
	// 	    }
	// 	}
	// }
	
	
});

router.afterEach((to,from,next) => {
	// let myurl = process.env.VUE_APP_REDIRECTURL
	// wxshare(myurl + to.path)
	
	// 返回列表时重置滚动条
	if(to.path == '/index/yhlist' || to.path == '/index/ghlist' || to.path == '/index/sflist'){
		let top = store.state.hua.scrolltop
		console.log(top)
		setTimeout(()=>{
			window.scroll(0,top)
		},300)
	}
})